import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Chip,
  Box,
  Tooltip
} from '@mui/material';
import { Star, StarBorder, ChevronRight } from '@mui/icons-material';

/**
 * List view item for a dashboard module
 * Compact display with icon, name, description, and optional badge
 */
const DashboardModuleListItem = ({
  module,
  onClick,
  isPinned = false,
  onPinToggle,
  badge = null
}) => {
  const Icon = module.icon;

  const handlePinClick = (e) => {
    e.stopPropagation();
    onPinToggle?.();
  };

  return (
    <ListItem
      disablePadding
      sx={{
        mb: 0.5,
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'grey.200',
        '&:hover': {
          borderColor: 'primary.light',
          bgcolor: 'grey.50'
        }
      }}
      secondaryAction={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {badge != null && badge > 0 && (
            <Chip
              label={badge}
              size="small"
              color="primary"
              sx={{ fontWeight: 600 }}
            />
          )}
          <Tooltip title={isPinned ? 'Remove from favorites' : 'Add to favorites'}>
            <IconButton
              size="small"
              onClick={handlePinClick}
            >
              {isPinned ? (
                <Star sx={{ color: 'warning.main' }} fontSize="small" />
              ) : (
                <StarBorder fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
          <ChevronRight color="action" />
        </Box>
      }
    >
      <ListItemButton onClick={onClick} sx={{ py: 1.5 }}>
        <ListItemIcon sx={{ minWidth: 44 }}>
          {Icon && <Icon color="primary" />}
        </ListItemIcon>
        <ListItemText
          primary={module.name}
          secondary={module.description}
          primaryTypographyProps={{
            fontWeight: 500
          }}
          secondaryTypographyProps={{
            variant: 'body2',
            sx: { opacity: 0.7 }
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default DashboardModuleListItem;
